import { useQuery } from '@tanstack/react-query'
import { agentsService } from '@/services/agentsService'
import { queryKeys } from '../keys'

// **Solo OpenAI, por ahora** (D9, decidido por Daniel el 2026-09-26: «por ahora
// no tenemos Gemini»). Y no es solo que no se use: medido ese día, Gemini
// rechaza una herramienta del Brain (`document_ids` es una lista sin decir de
// qué) y el turno falla. Añadir un proveedor aquí es comprobar antes que sus
// turnos con herramientas terminan.
const BRAIN_PROVIDERS = new Set(['openai'])

/** The models a Brain conversation can use: the catalog's, with a key, from a
 *  provider the Brain has been checked against. The same list Agent Studio
 *  offers, so a model is never offered in one place and not the other. */
export function useBrainModelsQuery() {
  return useQuery({
    queryKey: queryKeys.brain.models(),
    queryFn: async () => (await agentsService.listAvailableModels()).items.filter((m) => BRAIN_PROVIDERS.has(m.provider)),
    staleTime: 5 * 60_000,
  })
}
